export default {"src":"/_next/static/media/elit_icon.59aa4993.svg","height":92,"width":89,"blurWidth":0,"blurHeight":0};